import type { FilterOption } from "../schema/FilterOption.js";
import type { Locale, LocalizedString } from "../schema/Locale.js";

// eslint-disable-next-line @typescript-eslint/unified-signatures
export function objectToOptions<Key extends PropertyKey>(
	obj: Record<Key, LocalizedString>,
	locale: Locale,
): FilterOption[];
export function objectToOptions<Key extends PropertyKey>(obj: Record<Key, string>): FilterOption[];
export function objectToOptions<Key extends PropertyKey>(
	obj: Record<Key, string | LocalizedString>,
	locale?: Locale,
): FilterOption[] {
	return Object.entries(obj).map(([value, label]) => {
		return {
			value,
			label: locale !== undefined ? String((label as LocalizedString)[locale]) : String(label),
		};
	});
}
